import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-prescription-map',
  templateUrl: './prescription-map.component.html',
  styleUrls: ['./prescription-map.component.scss'],
})
export class PrescriptionMapComponent {
  @Input() mapHeight: string;
}
